module.exports = __webpack_public_path__ + "static/email/img/icon_bak.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_bak.png
// module id = CHGJ
// module chunks = 1